module.exports = __webpack_public_path__ + "img/mariette-rousseau.98bf4542.png";